function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 8.734375 6.519531 C 8.734375 5.753906 9.371094 5.457031 10.394531 5.457031 C 11.882812 5.457031 13.777344 5.914062 15.265625 6.714844 L 15.265625 2.105469 C 13.644531 1.457031 12.023438 1.210938 10.398438 1.210938 C 6.429688 1.210938 3.78125 3.285156 3.78125 6.75 C 3.78125 12.171875 11.222656 11.292969 11.222656 13.628906 C 11.222656 14.535156 10.4375 14.828125 9.34375 14.828125 C 7.722656 14.828125 5.628906 14.160156 3.984375 13.265625 L 3.984375 17.675781 C 5.675781 18.40625 7.496094 18.785156 9.339844 18.789062 C 13.410156 18.789062 16.214844 17.039062 16.214844 13.515625 C 16.21875 7.675781 8.734375 8.722656 8.734375 6.519531 Z M 8.734375 6.519531 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.4fd1bb3338cdcdfe6f66bb3f2e10d361.svg";
export { ForwardRef as ReactComponent };